import React from 'react';
import { useSelector } from 'react-redux';
import InactiveComponent from './components/InactiveComponent/InactiveComponent';
import ActiveComponent from './components/ActiveComponent/ActiveComponent';

const Content = ({ request, actionProps, canChange = true }) => {
  const { CanChangeWarranty } = useSelector(
    (state) => state.authentication.userInfo
  );

  return CanChangeWarranty && canChange ? (
    <ActiveComponent
      request={request}
      actionProps={actionProps}
    />
  ) : (
    <InactiveComponent
      warrantyId={request.garantyId}
      actionProps={actionProps}
    />
  );
};

export default Content;
